import { render, staticRenderFns } from "./carousel-images.vue?vue&type=template&id=4de59788&"
import script from "./carousel-images.vue?vue&type=script&lang=js&"
export * from "./carousel-images.vue?vue&type=script&lang=js&"
import style0 from "./carousel-images.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports